<template>
  <v-main>
    <v-container fluid fill-height>
      <app-loading v-if="loading"></app-loading>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md8 lg8>
          <v-card class="elevation-2">
            <v-toolbar color="primary" dark>
              <v-toolbar-title class="black--text"><v-icon class="grey--text mr-2">storefront</v-icon> Listings</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn outlined class="white blue--text" @click="newListingDialog = true">
                <v-icon>add</v-icon>
                new Listing
              </v-btn>

            </v-toolbar>

            <v-divider></v-divider>
            <v-card-text v-if="listings.length !== 0">

              <v-list v-for="(listing, index) in listings" :key="listing.id">
                <v-list-item @click="$router.push('/listing/' + listing.id)" >
                  <v-list-item-title class="subheading">
                    {{listing.listingName}}
                  </v-list-item-title>
                  <v-list-item-action>
                    <v-btn small outlined rounded v-if="listing.active" class="black--text font-weight-bold">Online</v-btn>
<!--                    <v-icon v-else class="blue&#45;&#45;text">radio_button_unchecked</v-icon>-->
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="index < (listings.length - 1)">
                </v-divider>
              </v-list>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="newListingDialog"
              ref="dialog"
              persistent
              width="290px"
    >
      <v-card>
        <v-card-title>
          <div class="white black--text text-xs-center font-weight-thin display-1" v-if="listingName === ''">New Listing</div>
          <div class="white black--text text-xs-center font-weight-thin display-1" v-else>{{listingName}}</div>
        </v-card-title>
        <v-card-text v-if="!loading">
          <v-text-field
              label="Listing name"
              v-model="listingName"
              class="blue--text"
          >
          </v-text-field>
        </v-card-text>
        <app-loading v-else></app-loading>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="newListingDialog = false" text>cancel</v-btn>
          <v-btn @click="createListing" dark class="blue">Create Listing</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-main>
</template>
<script>
import {addDoc, collection, doc, onSnapshot, updateDoc} from "firebase/firestore";

export default {
  data: () => ({
    listings: [],
    newListingDialog: false,
    listingName: ''
  }),
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  created() {
    //console.log(this.user)
    this.$store.dispatch('setLoading', true)
    let db = this.$store.state.db
    // fetches items associated by this number
    let listingRef = collection(db, 'users', this.user.uid + '/listings')
    onSnapshot(listingRef, res => {
      if (res && res.empty !== true) {
        let listings = []
        let sortedListings = []
        res.forEach(doc => {
          let data = doc.data()
          // console.log(data.id)
          listings.push(data)
        })
        sortedListings = listings.sort((a, b) => b.created - a.created)
        this.listings = sortedListings
      }
      this.$store.dispatch('setLoading', false)
    })

  },
  methods: {
    createListing () {
      this.$store.dispatch('setLoading', true)
      let db = this.$store.state.db
      let listingsRef = collection(db, 'users', this.user.uid + '/listings')
      let listing = {
        created: Date.now(),
        listingName: this.listingName,
        active: false,
        userNote: '',
        publicListing: {listingName: this.listingName, note: '', headerImages: [], footerImages: [], socialIcons: []},
      }
      addDoc(listingsRef, listing)
          .then(res => {
            listing.id = res.id
            let listingRef = doc(db, 'users', this.user.uid + '/listings/' + res.id)
            return updateDoc(listingRef, listing)
          })
          .catch(err => {
            this.$store.dispatch('setError', err)
            this.newListingDialog = false
            this.listingName = ''
            this.$store.dispatch('setLoading', false)
          })
      this.newListingDialog = false
      this.listingName = ''
      this.$store.dispatch('setLoading', false)
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }

}
</script>

